<template>
  <h5 class="fs-5" :class="[colour, fontWeight, lineHeight]">
    {{ text }}
  </h5>
</template>

<script>
export default {
  name: "HeaderFive",
  props: {
    text: {
      type: String,
      required: true,
    },
    colour: {
      type: String,
      required: false,
      default: "",
    },
    fontWeight: {
      type: String,
      required: false,
      default: "",
    },
    lineHeight: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>

<style scoped></style>
